<script>
	import { onMount, createEventDispatcher } from 'svelte';
	import { fade } from 'svelte/transition';
    import Identity from 'svelte-key';
    import { generateID, fetchData, getLocalServer } from '../utils/Data.svelte';
	import { sortById, groupSort } from '../utils/Sort.svelte';
    import { albums, refreshCircle, cloudCircle } from 'ionicons/icons/index.mjs';

    export let keys;
    export let config;
    export let links;
    export let query;
    export let groups;
    let toggle = {};
    Object.keys(groups).map(function (group) {
        toggle[group] = false;
    });
    export let map;
    export let layers;
    export let mapLoaded;
    export let tooltips;
    let fsLayers = [];

    const dispatch = createEventDispatcher();
    function sendMessage(message) {
		dispatch('message', message);
    }

    onMount(async () => {  
        if (window.platform == "Android") {
            fsLayers = JSON.parse(androidAdapter.getLayers());
        }
        else if (window.platform == "Windows") {
            let [res, err]  = await fetchData(getLocalServer() + "/tilesets");
            if (err) {
                console.log(err);
            }
            else {
                fsLayers = res.data.tilesets;
            }
        }
    });

    function updateFsVisibility(checked, data) {
        var layer = map.getLayer(data.id);
        if (!layer) {
            var id = generateID();
            if (platform == "Android") {
                map.addSource(id, {
                    attribution: "",
                    maxzoom: 18,
                    minzoom: 0,
                    scheme: "xyz",
                    tileSize: 256,
                    tiles: ["https://tilesets.geosync.cloud" + data.path + "/{z}/{x}/{y}.png"],
                    type: "raster"
                })
            }
            else if (platform == "Windows") {
                map.addSource(id, {
                    attribution: "",
                    maxzoom: 18,
                    minzoom: 0,
                    scheme: "xyz",
                    tileSize: 256,
                    tiles: ["http://localhost:6278/tiles/" + data.path + "/{z}/{x}/{y}.png"],
                    type: "raster"
                })
            }
            else {
                return;
            }
            var layerList = map.getStyle().layers;
            const found = layerList.find(function (element) {
              return !element.id.startsWith("__openmaptiles") && element.type != "raster"
            });
            var before = null;
            if (found)
              before = found.id;
              
            map.addLayer({
                id: data.id,
                source: id,
                type: "raster"
            }, before)
        }
        else {
            if (checked) {
                map.setLayoutProperty(layer.id, "visibility", "visible")
            }
            else {
                map.setLayoutProperty(layer.id, "visibility", "none")
            }
        }
    }

    function updateVisibility(e) {
        var layer = map.getLayer(e.target.title)
        var clusters = null;
        var clusterCt = null;
        if (layer.type === "circle") {
            var clusters = map.getLayer("__clusters__" + layer.id);
            var clusterCt = map.getLayer("__cluster-count__" + layer.id);
        }
        if (e.target.checked) {
            map.setLayoutProperty(layer.id, "visibility", "visible")
            if (clusters)
                map.setLayoutProperty(clusters.id, "visibility", "visible");
            if (clusterCt)
                map.setLayoutProperty(clusterCt.id, "visibility", "visible");
            if (layer.metadata["geosync:live"]) {
                map.fire("moveend");
            }
        }
        else {
            map.setLayoutProperty(layer.id, "visibility", "none")
            if (clusters)
                map.setLayoutProperty(clusters.id, "visibility", "none");
            if (clusterCt)
                map.setLayoutProperty(clusterCt.id, "visibility", "none");
        }
    }

    function updateGroupVisibility(e) {
        var group = groups[e.target.title];
        group.map(function (item) {
            var layer = map.getLayer(item.id);
            var clusters = null;
            var clusterCt = null;
            if (layer.type === "circle") {
                var clusters = map.getLayer("__clusters__" + layer.id);
                var clusterCt = map.getLayer("__cluster-count__" + layer.id);
            }
            if (e.target.checked) {
                map.setLayoutProperty(layer.id, "visibility", "visible")
                if (clusters)
                    map.setLayoutProperty(clusters.id, "visibility", "visible");
                if (clusterCt)
                    map.setLayoutProperty(clusterCt.id, "visibility", "visible");
            }
            else {
                map.setLayoutProperty(layer.id, "visibility", "none")
                if (clusters)
                    map.setLayoutProperty(clusters.id, "visibility", "none");
                if (clusterCt)
                    map.setLayoutProperty(clusterCt.id, "visibility", "none");
            }
        });
    }

    function getLayerLegend(id) {
        if (!map) {
            return;
        }
        var layer = map.getLayer(id);
        if (!layer) {
            return;
        }
        var color = "#000000";
        if (layer.type == "circle") {
        color = map.getPaintProperty(layer.id, "circle-color");
        if (!color) {
            color = "#000000";
        }
        return `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" style="width:20px;">
            <circle cx="50" cy="50" r="25" fill="${color}" />
        </svg>`;
        } else if (layer.type == "line") {
        color = map.getPaintProperty(layer.id, "line-color");
        if (!color) {
            color = "#000000";
        }
        return `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" style="width:20px;">
            <path d="M 20,90 90,20" style="stroke:${color};stroke-width:10" />
        </svg>`;
        } else if (layer.type == "fill") {
        color = map.getPaintProperty(layer.id, "fill-color");
        if (!color) {
            color = "#000000";
        }
        return `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" style="width:20px;">
            <rect x="15" y="15" width="70" height="70" fill="${color}" />
        </svg>`;
        } else if (layer.type == "fill-extrusion") {
        color = map.getPaintProperty(layer.id, "fill-extrusion-color");
        if (!color) {
            color = "#000000";
        }
        return `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" style="width:20px;">
            <rect x="20" y="40" width="30" height="50" fill="${color}" />
            <rect x="60" y="15" width="30" height="75" fill="${color}" />
        </svg>`;
        } else if (layer.type == "heatmap") {
        return `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" style="width:20px;">
            <circle cx="50" cy="50" r="40" fill="yellow" />
            <circle cx="50" cy="50" r="35" fill="orange" />
            <circle cx="50" cy="50" r="15" fill="red" />
        </svg>`;
        } else if (layer.type == "hillshade") {
        color = map.getPaintProperty(layer.id, "hillshade-accent-color");
        if (!color) {
            color = "#000000";
        }
        return `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" style="width:20px;">
            <path d="M 20 80 C 50 20, 60 20, 90 80" fill="${color}" />
        </svg>`;
        } else if (layer.type == "raster") {
        return `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" style="width:20px;">
            <rect x="25" y="20" width="30" height="30" />
            <rect x="65" y="20" width="30" height="30" />
            <rect x="25" y="60" width="30" height="30" />
        </svg>`;
        } else if (layer.type == "symbol") {
        var symbol = map.getLayoutProperty(layer.id, "icon-image");
        if (symbol) {
            return `<img src="/svg/${symbol}.svg" style="width:24px;margin-top:-3px;" />`;
        } else {
            var color = map.getPaintProperty(layer.id, "text-color");
            if (!color) {
            color = "#000000";
            }
            let font = map.getLayoutProperty(layer.id, "text-font");
            let text = map.getLayoutProperty(layer.id, "text-field") || "";
            if (font == "Font Awesome Solid" && text != "") {
            let icons = "";
            let style = `font-family:fa-solid;`;
            if (Array.isArray(text)) {
                text.map(function (icon) {
                    if (icon.length == 1) {
                        icons = icons + icon;
                    }
                })
            }
            else {
                style = style + `color:${color}`;
                icons = text;
            }
            return `<span style="${style}">${icons}</span>`;
            } else {
            return `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" style="width:20px;">
                <path d="M 32,32 L 80,32 L 80,44 L 62 44 L 62 80 L 50 80 L 50 44 L 32 44 Z" fill="${color}" />
            </svg>`;
            }
        }
        } else if (layer.type == "custom") {
            return `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" style="width:20px;">
                <path d="M50,10L15.359,30L15.359,70L50,90L84.641,70L84.641,30L50,10ZM50,15L78.146,31.25L50,47.5L21.854,31.25L50,15ZM47.835,83.75L19.689,67.5L19.689,35L48.038,51.367L47.835,83.75Z" stroke="none">
            </svg>`;
        }
    }
</script>

<div in:fade>
	<div class="tile tile-centered pr-2 pl-2">
		<div class="tile-content">
			<div class="divider" data-content="LAYERS"></div>
		</div>
        <div class="tile-action pr-1">
            <button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Reload Layers" on:click|stopPropagation={(e) => {
                e.currentTarget.blur();
                sendMessage({
                    type: "reloadall"
                })
            }}><i class="svg">{@html refreshCircle.md}</i></button>
        </div>
	</div>
    {#if mapLoaded}
        <Identity key={keys.layers}>
            {#each Object.keys(groups) as group}
                {#if !group.startsWith("__") && !group.startsWith("gl-draw-") && !group.startsWith("reportlog")}
                    {#if groups[group].length > 1}
                        <div class="accordion">
                            <input type="checkbox" id={"group-" + group} name="accordion-checkbox" bind:checked={toggle[group]} hidden>
                            <label class="accordion-header" for={"group-" + group}>
                                <div class="tile tile-centered pl-1" style="padding-right:0.1rem;">
                                    <div class="tile-icon">
                                        {#if toggle[group]}
                                            <i class="icon icon-arrow-down centered"></i>
                                        {:else}
                                            <i class="icon icon-arrow-right centered"></i>
                                        {/if}
                                    </div>
                                    <div class="tile-content">
                                        <div class="tile-title">{group}</div>
                                    </div>
                                    <div class="tile-action">
                                        <div class="form-group">
                                        <label class="form-checkbox">
                                            <input type="checkbox" title={group} checked={false} indeterminate={true}
                                                on:change={updateGroupVisibility}
                                            />
                                            <i class="form-icon" />
                                        </label>
                                        </div>
                                    </div>
                                </div>    
                            </label>
                            <div class="accordion-body">
                                <ul class="menu menu-nav mb-2">
                                    {#each groups[group] as layer}
                                        <div class="tile tile-centered">
                                            {#if config.role > 2 && links[layer.id]}
                                                <div class="tile-icon">
                                                    <a class="btn btn-link {tooltips ? "tooltip tooltip-right" : ""}" data-tooltip="Download Layer" target="_blank" href={links[layer.id] + "?" + query}><i class="svg">{@html cloudCircle.ios}</i></a>
                                                </div>
                                            {:else}
                                                <div class="tile-icon"></div>
                                            {/if}
                                            <div class="tile-content">
                                                <div>
                                                    {@html getLayerLegend(layer.id)}
                                                </div>
                                                <div class="tile-title">{layer.id}</div>
                                            </div>
                                            <div class="tile-action">
                                                <div class="form-group">
                                                <label class="form-checkbox">
                                                    <input type="checkbox" title={layer.id} on:change={updateVisibility} bind:checked={layers[layer.id]} />
                                                    <i class="form-icon" />
                                                </label>
                                                </div>
                                            </div>
                                        </div>
                                    {/each}
                                </ul>
                            </div>
                        </div>
                    {:else}
                        <div class="tile tile-centered pl-2 mt-2">
                            {#if config.role > 2 && links[groups[group][0].id]}
                                <div class="tile-icon">
                                    <a class="btn btn-link {tooltips ? "tooltip tooltip-right" : ""}" data-tooltip="Download Layer" target="_blank" href={links[groups[group][0].id] + "?" + query}><i class="svg">{@html cloudCircle.ios}</i></a>
                                </div>
                            {:else}
                                <div class="tile-icon"></div>
                            {/if}
                            <div class="tile-content">
                                <div>
                                    {@html getLayerLegend(groups[group][0].id)}
                                </div>
                                <div class="tile-title">{ groups[group][0].id }</div>
                            </div>
                            <div class="tile-action">
                                <div class="form-group">
                                <label class="form-checkbox">
                                    <input type="checkbox" title={groups[group][0].id} on:change={updateVisibility} bind:checked={layers[groups[group][0].id]} />
                                    <i class="form-icon" />
                                </label>
                                </div>
                            </div>
                        </div>
                    {/if}
                {/if}
		    {/each}
            {#if fsLayers.length > 0}
                <div class="tile tile-centered pr-2 pl-2">
                    <div class="tile-content">
                        <div class="divider" data-content="FILESYSTEM"></div>
                    </div>
                </div>
                {#each fsLayers as layer}
                    <div class="tile tile-centered pl-2 mt-2">
                        <div class="tile-icon"></div>
                        <div class="tile-content">
                            <div>
                                {@html getLayerLegend(layer.id)}
                            </div>
                            <div class="tile-title">{layer.name.substring(0, 25)}</div>
                        </div>
                        <div class="tile-action">
                            <div class="form-group">
                            <label class="form-checkbox">
                                <input type="checkbox" title={layer.id} on:change={(e) => {
                                        e.currentTarget.blur();
                                        updateFsVisibility(e.target.checked, layer);
                                    }} bind:checked={layer.visible} />
                                <i class="form-icon" />
                            </label>
                            </div>
                        </div>
                    </div>
                {/each}
            {/if}
        </Identity>
    {/if}
</div>

<style>
    ::-webkit-scrollbar {
		width: 6px;
		background-color: #f7f8f9;
	}
	::-webkit-scrollbar-thumb {
		background-color: rgba(122,129,132, 1);
    }
    .form-group {
        margin: 0.2rem 0;
    }
    .tile .tile-icon {
        width: 1.4rem;
    }
    .tile-title {
        display: inline-block;
    }
	.accordion {
		min-height: 2rem;
	}
	.accordion .accordion-header {
		cursor: pointer;
		user-select: none;
        background-color: #00ab5f;
        padding: 0.2rem 0rem 0.2rem 0.4rem;
        height: 2rem;
        color: white;
	}
	.accordion-body {
		border-left: 1px solid #00ab5f;
		margin: 0;
        margin-left: 1rem;
		padding-left: 0.6rem;
    }
	.tile-action .btn {
		padding: 0;
		margin: 0;
    }
    .menu {
        padding: 0;
    }
</style>